<template>
  <div class="couchbase-container app-container">
    <div class="couchbase-header bg-white">
      <div class="couchbase-header-bottom">
        <!-- <list-search @listSearchEvn="listSearchEvn" /> -->
        <div class="couchbase-header-bottom-date">
          <div class="booxCloud-date-select">
            <span
              v-for="item in dateType"
              :key="item.type"
              class="booxCloud-date-select-item"
              :class="{
                'booxCloud-date-select-active': type === item.type
              }"
              @click="changeType(item.type)"
              >{{ item.label }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="couchbase-main" v-bar>
      <div>
        <userLineChart v-if="itemCount" :chartData="itemCount"> </userLineChart>
        <couchbaseDiskUsed v-if="diskUsed" :chartData="diskUsed">
        </couchbaseDiskUsed>
      </div>
    </div>
  </div>
</template>

<script>
import userLineChart from "./components/userLineChart";
import couchbaseDiskUsed from "./components/couchbaseDiskUsed";

export default {
  components: {
    userLineChart,
    couchbaseDiskUsed
  },
  data() {
    return {
      itemCount: null,
      diskUsed: null,
      type: "day",
      itemCountParams: {
        target: "itemCount",
        type: "day"
      },
      diskUsedParams: {
        target: "diskUsed",
        type: "day"
      },
      dateType: [
        {
          type: "day",
          label: "天"
        },
        {
          type: "week",
          label: "周"
        },
        {
          type: "month",
          label: "月"
        },
        {
          type: "year",
          label: "年"
        }
      ]
    };
  },
  methods: {
    changeType(type) {
      if (this.type === type) return;
      this.type = type;
      this.itemCountParams.type = type;
      this.diskUsedParams.type = type;
      this.getItemCount();
      this.getDiskUsed();
    },
    async getItemCount() {
      try {
        let res = await this.$http.getCouchbase(this.itemCountParams);
        res.data.seriesName = "itemCount";
        this.itemCount = res.data;
      } catch (error) {
        throw error;
      }
    },
    async getDiskUsed() {
      try {
        let res = await this.$http.getCouchbase(this.diskUsedParams);
        res.data.seriesName = "diskUsed";
        this.diskUsed = res.data;
      } catch (error) {
        throw error;
      }
    }
  },
  mounted() {
    this.getItemCount();
    this.getDiskUsed();
  }
};
</script>

<style lang="scss">
.couchbase-container {
  .couchbase-header {
    padding: 10px 50px;
    .couchbase-header-top {
      display: flex;
      justify-content: space-around;
      padding: 20px 0 30px;
      border-bottom: 1px solid $globalBorderColor;
    }
    .couchbase-header-bottom {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      .couchbase-header-bottom-date {
        display: flex;
        align-items: center;
        .booxCloud-date-select {
          .booxCloud-date-select-item {
            display: inline-block;
            padding: 6px 12px;
            margin-left: 20px;
            font-size: 14px;
            border-radius: 4px;
            border: none;
            outline: none;
            cursor: pointer;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            background: #ccc;
            color: #fff;
          }
          .booxCloud-date-select-active {
            background: #bf735b;
            color: #fff;
          }
        }
      }
    }
  }
  .booxCloud-date-select {
    .booxCloud-date-select-item {
      display: inline-block;
      padding: 6px 12px;
      margin-left: 20px;
      font-size: 14px;
      border-radius: 4px;
      border: none;
      outline: none;
      cursor: pointer;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      background: #ccc;
      color: #fff;
    }
    .booxCloud-date-select-active {
      background: #bf735b;
      color: #fff;
    }
  }
  .couchbase-main {
    flex: 1;
    padding: 20px;
    overflow: hidden;
  }
}
</style>
